module.exports = __webpack_public_path__ + "static/media/cia08.01a2deee.png";